import React from 'react';
import classNames from 'classnames';
import noop from '../../../../../utils/noop';
import { ToggleButtonProps } from './types';

const ToggleButton = ({
  disabled = false,
  selected = false,
  label,
  onClick = noop,
  onKeyDown = noop,
  fullWidth = false,
  id,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onKeyDown(id);
    }
  };

  const handleClick = () => {
    onClick(id);
  };

  const classes = classNames('ws-ui-toggle-button', {
    'ws-ui-toggle-button--selected': selected,
    'ws-ui-toggle-button--fullwidth': fullWidth,
  });

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      type="button"
    >
      {label}
    </button>
  );
};

ToggleButton.propTypes = ToggleButtonProps;

export default ToggleButton;
